import { Link } from "react-router-dom";

const productLinks = [
  { name: "Features", href: "#features" },
  { name: "Pricing", href: "#pricing" },
  { name: "How It Works", href: "#how-it-works" },
  { name: "FAQ", href: "#faq" },
];

const companyLinks = [
  { name: "Sign In", href: "/login", isRoute: true },
  { name: "Contact", href: "mailto:support@mygarage.com" },
];

export default function Footer() {
  return (
    <footer className="border-t border-border-secondary bg-bg-primary">
      <div className="landing-container py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="text-lg font-semibold text-text-primary mb-3">
              My Garage
            </h3>
            <p className="text-sm text-text-tertiary max-w-sm leading-relaxed">
              The all-in-one management platform for modern auto repair shops.
              Jobs, inventory, storage, and invoicing — simplified.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-sm font-semibold text-text-primary mb-4">
              Product
            </h4>
            <ul className="space-y-3">
              {productLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-sm text-text-tertiary hover:text-text-primary transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-semibold text-text-primary mb-4">
              Company
            </h4>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.name}>
                  {link.isRoute ? (
                    <Link
                      to={link.href}
                      className="text-sm text-text-tertiary hover:text-text-primary transition-colors"
                    >
                      {link.name}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      className="text-sm text-text-tertiary hover:text-text-primary transition-colors"
                    >
                      {link.name}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-border-secondary">
          <p className="text-sm text-text-tertiary text-center">
            &copy; 2026 My Garage. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
